import { HttpClient } from '../http-client';
import type { BaseResponse } from '../types/common';
import type { RoleRegisterRequest, RoleRegisterResponse, RoleResponse, RoleUpdateRequest } from '../types/role.types';

class RoleService {
  private http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  async register(data: RoleRegisterRequest): Promise<RoleRegisterResponse> {
    return this.http.requestAndValidate<RoleRegisterResponse>('/roles/register', {
      method: 'POST',
      body: data
    });
  }

  async update(data: RoleUpdateRequest): Promise<RoleResponse> {
    return this.http.requestAndValidate<RoleResponse>('/roles/update', {
      method: 'POST',
      body: data
    });
  }

  async delete(id: string): Promise<BaseResponse> {
    return this.http.requestAndValidate<BaseResponse>('/roles/delete', {
      method: 'POST',
      body: { id }
    });
  }

  async getById(id: string): Promise<RoleResponse> {
    return this.http.requestAndValidate<RoleResponse>('/roles/get-by-id', {
      method: 'POST',
      body: { id }
    });
  }

  async getByCode(code: string, tenantId?: string): Promise<RoleResponse> {
    return this.http.requestAndValidate<RoleResponse>('/roles/get-by-code', {
      method: 'POST',
      body: { code, tenantId }
    });
  }
}

export { RoleService };
